import React from "react";
var ZoomContext = React.createContext({
    zoom: 1
});
export default ZoomContext;
